<section class="overflow-hidden">
  <div class="common-container">
    <h2>¿Que te apetece hoy?</h2>
    <div class="common-container flex justify-content-center mb-8">
      <a href="https://www.just-eat.es/restaurants-pizza-en-casa-palma/menu">
        <p-button size="large" [outlined]="true">
          <img
            src="assets/img/logotipos/just-eat-seeklogo@42w.png"
            alt="Logotipo Just Eat"
            class="w-3rem" />
          <span> Haz tu pedido en Just Eat </span>
        </p-button>
      </a>
    </div>

    <div class="">
      <p-tabView
        [scrollable]="true"
        styleClass="tabview-custom "
        class="stickyTabView"
        (onChange)="onTabChange()">
        <p-tabPanel header="Pizzas">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="tabview-icon ph-duotone ph-pizza"></i>

              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Pizzas
              </span>
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of pizzas">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Ensaladas">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="tabview-icon ph-duotone ph-bowl-food"></i>
              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Ensaladas</span
              >
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of salads">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Bebidas">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="tabview-icon ph-duotone ph-beer-bottle"></i>
              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Bebidas
              </span>
              <!-- <p-badge value="2" /> -->
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of drinks">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Bodega">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <!-- <p-avatar
              image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
              shape="circle"
            /> -->
              <i class="tabview-icon ph-duotone ph-wine"></i>
              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Bodega
              </span>
              <!-- <p-badge value="2" /> -->
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of wine_cellar">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Combos">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <!-- <p-avatar
            image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
            shape="circle"
          /> -->
              <i class="tabview-icon ph-duotone ph-ice-cream"></i>
              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Postres
              </span>
              <!-- <p-badge value="2" /> -->
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of desserts">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Combos">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <!-- <p-avatar
            image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
            shape="circle"
          /> -->
              <i class="tabview-icon ph-duotone ph-package"></i>
              <span class="font-bold white-space-nowrap m-0 hidden sm:block">
                Combos
              </span>
              <!-- <p-badge value="2" /> -->
            </div>
          </ng-template>

          <div class="product-list flex flex-wrap justify-content-center gap-4">
            <ng-container *ngFor="let item of combos">
              <app-product [product]="item"></app-product>
            </ng-container>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="common-container flex justify-content-center mb-8">
      <a href="https://www.just-eat.es/restaurants-pizza-en-casa-palma/menu">
        <p-button size="large" [outlined]="true">
          <img
            src="assets/img/logotipos/just-eat-seeklogo@42w.png"
            alt="Logotipo Just Eat"
            class="w-3rem" />
          <span> Haz tu pedido en Just Eat </span>
        </p-button>
      </a>
    </div>
  </div>
</section>
